import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  Box,
  Button,
  IconButton,
} from "@mui/joy";
import {
  Grow,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Autocomplete,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { centrado } from "../utils/Estilos";
import { theme2 } from "../theme";
import banner from "../assets/banner/publimed.jpg";
import fondo from "../assets/banner/fondo.jpg";
import flotante from "../assets/banner/flotante.jpg";
import { useIntersection } from "../navigation/Show";
import { useNavigate } from "react-router-dom";
import { testimoniosC, testimoniosV } from "../utils/Testimonios";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import RemoveIcon from "@mui/icons-material/Remove";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

const Numeros = () => {
  return (
    <Grid container sx={{ width: "90%", ...centrado }}>
      <Grid size={{ xs: 12, md: 4 }} sx={{ padding: "30px" }}>
        <Paper
          elevation={2}
          sx={{
            padding: "20px",
            minHeight: "250px",
            ...centrado,
            border: 1,
            borderRadius: "25px",
            borderColor: theme2.palette.primary.main,
          }}
        >
          <Box textAlign={"center"} sx={{ width: "100%" }}>
            <Typography variant="h2" fontWeight={"bold"} color="primary" pb={2}>
              <CountUp end={1000} duration={1} suffix="+" />
            </Typography>
            <Typography variant="h5" fontWeight={"bold"}>
              Profesionales
            </Typography>
            <Typography variant="h6">
              Que han participado con nosotros.
            </Typography>
          </Box>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }} sx={{ padding: "30px" }}>
        <Paper
          elevation={2}
          sx={{
            padding: "20px",
            minHeight: "250px",
            ...centrado,
            border: 1,
            borderRadius: "25px",
            borderColor: theme2.palette.primary.main,
          }}
        >
          <Box textAlign={"center"} sx={{ width: "100%" }}>
            <Typography variant="h2" fontWeight={"bold"} color="primary" pb={2}>
              <CountUp end={25} duration={1} suffix="+" />
            </Typography>
            <Typography variant="h5" fontWeight={"bold"}>
              Libros Médicos
            </Typography>
            <Typography variant="h6">Publicados por Nosotros</Typography>
          </Box>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }} sx={{ padding: "30px" }}>
        <Paper
          elevation={2}
          sx={{
            padding: "20px",
            minHeight: "250px",
            ...centrado,
            border: 1,
            borderRadius: "25px",
            borderColor: theme2.palette.primary.main,
          }}
        >
          <Box textAlign={"center"}>
            <Typography variant="h2" fontWeight={"bold"} color="primary" pb={2}>
              <CountUp end={70} duration={1} suffix="+" />
            </Typography>
            <Typography variant="h5" fontWeight={"bold"}>
              Artículos Médicos
            </Typography>
            <Typography variant="h6">Publicados por Nosotros</Typography>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

const Contenido = ({ slides }) => {
  return (
    <Swiper
      slidesPerView={slides}
      loop={true}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      modules={[Pagination, Navigation]}
    >
      {testimoniosV.map((val, index) => (
        <SwiperSlide
          key={index}
          style={{
            height: "50vh",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Box>
            <video controls style={{ height: "100%" }}>
              <source src={val} type="video/mp4" />
            </video>
          </Box>
        </SwiperSlide>
      ))}
      {testimoniosC.map((val, index) => (
        <SwiperSlide
          key={index}
          style={{
            height: "50vh",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
            <img alt={"Foto" + index} style={{ height: "100%" }} src={val} />
          </Box>
          <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
            <img alt={"Foto" + index} style={{ width: "100%" }} src={val} />
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export const Principal = () => {
  const navigate = useNavigate();

  const especialidades = useSelector(
    (state) => state.especialidades?.especialidades ?? [],
  );

  const triggerRef = useRef(null);
  const isVisible = useIntersection(triggerRef, "0px");

  const triggerRef2 = useRef(null);
  const isVisible2 = useIntersection(triggerRef2, "0px");
  const [preguntas, setPreguntas] = useState([]);

  const [mostrar, setMostrar] = useState(true);

  const [productos, setProductos] = useState([]);

  const [item, setItem] = useState({});

  const [open, setOpen] = useState(false);

  useEffect(() => {
    cargar();
  }, []);

  const dispatch = useDispatch();
  const carrito = useSelector((state) => state.carrito?.carro ?? []);

  function formatear(listaD) {
    let grupos = listaD.reduce((acumulador, el) => {
      const clave = `${el?.producto?.id}_${el?.eleccion}_${el?.espe}`;
      if (!acumulador[clave]) {
        acumulador[clave] = {
          ...el,
        };
      }
      return acumulador;
    }, {});

    let final = [];

    for (const el of Object.keys(grupos)) {
      let val = grupos[el];
      let precio = !isNaN(val?.eleccion)
        ? [val?.producto?.precio1, val?.producto?.precio2][val?.eleccion]
        : val?.producto?.precio;
      precio = parseFloat(precio).toFixed(2);
      final.push({
        ...val,
        precioFinal: precio,
        total: parseFloat(precio).toFixed(2),
      });
    }
    dispatch({
      type: "CARRO_SUCCESS",
      payload: {
        carro: final,
      },
    });
    localStorage.setItem("carritoPublimed", JSON.stringify(final));
    setItem({});
    setOpen(false);
    Swal.fire({
      icon: "success",
      text: "Producto añadido al carrito",
    });
  }

  function cargar() {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch("https://portal.publimed.net/api/v1/CPregunta", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setPreguntas(res.list);
      })
      .catch((error) => console.error(error));

    fetch(
      `https://portal.publimed.net/api/v1/CPlanArticulo?searchParams={"where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"}],
      "select": ["id","name","deleted","description","precio", "articulos"]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setProductos(res.list.sort((a, b) => a.articulos - b.articulos));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <Box>
      <Helmet>
        <title>{"Publimed Store"}</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: "url(" + banner + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "500px",
          width: "100%",
        }}
      />
      <Box mb={2} sx={{ marginTop: "-120px", ...centrado, width: "100%" }}>
        <Numeros />
      </Box>

      <Box pt={10} pb={2}>
        <Typography variant="h2" fontWeight={"bold"} align="center">
          ¿Qué ofrecemos?
        </Typography>
      </Box>
      <Box mb={2} sx={{ ...centrado, width: "100%" }}>
        <Grid container sx={{ width: "90%", ...centrado }}>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              padding: "20px",
            }}
          >
            <Paper
              elevation={2}
              sx={{
                textAlign: "center",
                padding: "50px",
                border: 1,
                minHeight: "300px",
                borderRadius: "25px",
                borderColor: theme2.palette.primary.main,
                ...centrado,
              }}
            >
              <Box>
                <Typography variant="h4" fontWeight={"bold"}>
                  Publicaciones Médicas
                </Typography>
                <br />
                <Button size="lg" onClick={() => navigate("/publicaciones")}>
                  Comprar Ahora
                </Button>
              </Box>
            </Paper>
          </Grid>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              padding: "20px",
            }}
          >
            <Paper
              elevation={2}
              sx={{
                textAlign: "center",
                padding: "50px",
                border: 1,
                minHeight: "300px",
                borderRadius: "25px",
                borderColor: theme2.palette.primary.main,
                width: "100%",
                ...centrado,
              }}
            >
              <Box>
                <Typography variant="h4" fontWeight={"bold"}>
                  Cursos
                </Typography>
                <br />

                <Button size="lg" onClick={() => navigate("/cursos")}>
                  Comprar Ahora
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Grow in={isVisible2}>
        <Box
          mt={5}
          sx={{
            position: "fixed",
            width: "100%",
            zIndex: 100,
            top: "50px",
            padding: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              padding: 0,
              margin: 0,
              zIndex: 200,
            }}
          >
            <IconButton
              color={mostrar ? "danger" : "primary"}
              variant="solid"
              onClick={() => setMostrar(!mostrar)}
              sx={{ position: "absolute", zIndex: 200, marginTop: -2 }}
            >
              {mostrar ? <RemoveIcon /> : <KeyboardDoubleArrowLeftIcon />}
            </IconButton>
          </Box>
          {mostrar && (
            <>
              <Box
                sx={{
                  display: { md: "flex", sm: "none", xs: "none" },
                  right: 0,
                  padding: 0,
                  position: "absolute",
                  margin: 0,
                }}
              >
                <img
                  style={{
                    borderRadius: "25px 0px 0px 25px",
                  }}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
                    )
                  }
                  src={flotante}
                  alt="flotante"
                  title="publicacion"
                  width={"200px"}
                />
              </Box>
              <Box
                sx={{
                  ...centrado,
                  display: { md: "none", sm: "flex", xs: "none" },
                  right: 0,
                  padding: 0,
                  position: "absolute",
                  margin: 0,
                }}
              >
                <img
                  style={{
                    borderRadius: "25px 0px 0px 25px",
                  }}
                  src={flotante}
                  alt="flotante"
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
                    )
                  }
                  title="publicacion"
                  width={"150px"}
                />
              </Box>

              <Box
                sx={{
                  ...centrado,
                  display: { md: "none", sm: "none", xs: "flex" },
                  right: 0,
                  padding: 0,
                  position: "absolute",
                  margin: 0,
                }}
              >
                <img
                  style={{
                    borderRadius: "25px 0px 0px 25px",
                  }}
                  src={flotante}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
                    )
                  }
                  alt="flotante"
                  title="publicacion"
                  width={"100px"}
                />
              </Box>
            </>
          )}
        </Box>
      </Grow>

      {productos.length > 0 && (
        <>
          <Box sx={{ ...centrado, width: "100%" }} pt={2}>
            <Typography
              variant="h4"
              fontWeight={"bold"}
              sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
            >
              Adquiere tu publicación con los siguientes planes
            </Typography>
          </Box>
          <Box mb={2} sx={{ ...centrado, width: "100%" }}>
            <Box
              pt={5}
              sx={{
                ...centrado,
                flexWrap: "wrap",
                gap: 2,
                alignItems: "stretch",
                justifyContent: { xs: "center", sm: "space-evenly" },
              }}
            >
              {productos.map((val) => (
                <Paper
                  key={val.id}
                  elevation={2}
                  my={2}
                  sx={{
                    border: 1,
                    borderRadius: "25px",
                    borderColor: theme2.palette.primary.main,
                    padding: 4,
                    width: { xs: "80%", sm: "70%", md: "30%" },
                  }}
                >
                  <Typography fontSize={"30px"} fontWeight={"bold"}>
                    {val.name}
                  </Typography>
                  <Typography fontSize={"25px"}>
                    {val.articulos} artículos
                  </Typography>

                  <Typography
                    fontSize={"30px"}
                    color={theme2.palette.primary.main}
                    fontWeight={"bold"}
                    align="right"
                  >
                    ${val.precio.toFixed(2)}
                  </Typography>

                  {/*  <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"right"}
              >
               {val.name?.includes("edium") ? (
                    <img src={medium} height={"80px"} alt="item"/>
                  ) : val.name?.includes("remium") ? (
                    <img src={premium} height={"80px"} alt="item"/>
                  ) : (
                    <img src={basico} height={"80px"} alt="item"/>
                  )}
                <Typography
                  fontSize={"30px"}
                  color={theme2.palette.primary.main}
                  fontWeight={"bold"}
                >
                  ${val.precio.toFixed(2)}
                </Typography>
              </Box> */}

                  <Box pt={3}>
                    <Typography
                      fontSize={"18px"}
                      fontWeight={"normal"}
                      sx={{
                        wordBreak: "break-word",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {val.description}
                    </Typography>
                  </Box>

                  <Box sx={{ textAlign: "center" }} pt={2}>
                    <Button
                      sx={{ paddingX: "25px", paddingY: "10px" }}
                      onClick={() => {
                        setItem({ ...val });
                        setOpen(true);
                      }}
                    >
                      <Typography color="white">Comprar</Typography>
                    </Button>
                  </Box>
                </Paper>
              ))}
            </Box>

            <Dialog
              open={open}
              fullWidth
              maxWidth="md"
              onClose={() => {
                setOpen(false);
                setItem({});
              }}
            >
              <DialogTitle>
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center" }}
                  fontWeight={"bold"}
                >
                  {item.name} - {item.articulos} artículos
                </Typography>
              </DialogTitle>

              <DialogContent>
                <Box>
                  <Typography variant="h6">
                    Escoja las especialidades de su interes
                  </Typography>
                  <Autocomplete
                    size="small"
                    multiple
                    value={item?.espe ?? []}
                    onChange={(e, t) => {
                      setItem({ ...item, espe: t });
                    }}
                    options={especialidades}
                    renderInput={(params) => (
                      <TextField autoComplete="off" {...params} />
                    )}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  color="danger"
                  onClick={() => {
                    setItem({});
                    setOpen(false);
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  disabled={!(item?.espe?.length > 0)}
                  onClick={() => {
                    let lis = carrito.filter(
                      (va) => !(va?.producto?.id === item?.id),
                    );
                    lis.push({
                      producto: item,
                      espe: item.espe,
                    });

                    formatear(lis);
                  }}
                >
                  Agregar al carrito
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </>
      )}

      <Box
        mb={2}
        mt={2}
        sx={{
          backgroundImage: "url(" + fondo + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "400px",
          ...centrado,
          width: "100%",
        }}
        ref={triggerRef}
      >
        <Box
          sx={{
            padding: "75px",
            color: "white",
            width: "100%",
            background: "rgba(99, 107, 116, 0.7)",
            minHeight: "400px",
          }}
        >
          <Grid container sx={{ width: "100%" }}>
            <Grow in={isVisible}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h4" fontWeight={"bold"}>
                  Acerca de Publimed
                </Typography>
                <br />
                <Typography variant="h5">
                  Publimed es una empresa dedicada al mejoramiento del
                  profesional de la salud, dándoles las herramientas necesarias
                  y más convenientes para incrementar sus conocimientos, y estar
                  más capacitados para su entorno laboral. También aportar con
                  información actual sobre enfermedades que acontecen en nuestro
                  país.
                </Typography>
              </Grid>
            </Grow>
          </Grid>
        </Box>
      </Box>

      <Box ref={triggerRef2}>
        <Box pt={2}>
          <Typography variant="h4" fontWeight={"bold"} align="center">
            Testimonios
          </Typography>
        </Box>

        <Box
          mb={2}
          sx={{
            display: { xs: "none", sm: "none", lg: "flex" },
            width: "90%",
            marginX: "auto",
            justifyContent: "space-around",
            overflowX: "auto",
            gap: 3,
            padding: "20px",
          }}
        >
          <Contenido slides={2} />
        </Box>

        <Box
          mb={2}
          sx={{
            display: { xs: "flex", sm: "flex", lg: "none" },
            width: "90%",
            marginX: "auto",
            justifyContent: "space-around",
            overflowX: "auto",
            gap: 3,
            padding: "20px",
          }}
        >
          <Contenido slides={1} />
        </Box>

        {preguntas?.length > 0 && (
          <Box
            mt={10}
            mb={2}
            sx={{
              bgcolor: "#C7DFF7",
              padding: "50px",
            }}
          >
            <Typography variant="h4" fontWeight={"bold"} align={"center"}>
              Preguntas Frecuentes
            </Typography>
            <Grid pt={5} container sx={{ width: "100%", ...centrado }}>
              <Grid size={{ xs: 12, md: 10 }} sx={{ padding: "20px" }}>
                <AccordionGroup
                  variant="soft"
                  size="lg"
                  sx={{
                    borderRadius: "10px",
                  }}
                >
                  {preguntas.map((val, index) => (
                    <Accordion
                      key={val?.id}
                      sx={{ color: "black" }}
                      defaultExpanded={index === 0}
                    >
                      <AccordionSummary sx={{ padding: "15px" }}>
                        <Typography variant="h6" fontWeight={"bold"}>
                          {val?.name}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          wordBreak: "break-word",
                          whiteSpace: "pre-line",
                          bgcolor: "white",
                        }}
                      >
                        <Typography variant="body1">
                          {val?.description}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </AccordionGroup>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};
